import { render, staticRenderFns } from "./TotalCounters.vue?vue&type=template&id=44cf5b9d&"
import script from "./TotalCounters.vue?vue&type=script&lang=js&"
export * from "./TotalCounters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports